import React, { useState, useRef } from 'react';
import propTypes from 'prop-types';
import { Select, MenuItem, ListSubheader, TextField } from '@mui/material';

const SearchableSelect = ({
  options,
  value,
  onChange,
  disabled,
  renderOption,
  placeholder
}) => {
  const [search, setSearch] = useState('');
  const searchInputRef = useRef(null);

  // Utilidad para obtener un label string para buscar
  const getOptionLabel = (option) => {
    if (typeof option === 'string') return option;
    if (option?.value) return String(option.value);
    if (option?.title) return String(option.title);
    if (option?.name) return String(option.name);
    if (option?.description) return String(option.description);
    if (option?.id) return String(option.id);
    return '';
  };

  const filteredOptions = options.filter((opt) =>
    getOptionLabel(opt).toLowerCase().includes(search.toLowerCase())
  );

  const handleOpen = () => {
    setTimeout(() => {
      searchInputRef.current?.focus();
    }, 100);
  };

  const getOptionValue = (option) =>
    String(option?.id ?? option?.key ?? option?.value ?? '');

  return (
    <Select
      fullWidth
      size="small"
      value={value}
      onChange={onChange}
      disabled={disabled}
      onOpen={handleOpen}
      displayEmpty
      MenuProps={{
        autoFocus: false,
        PaperProps: {
          onMouseDown: (e) => e.stopPropagation(),
          style: { maxHeight: 300 },
        },
        disableScrollLock: true,
      }}
      renderValue={(selected) => {
        if (!selected) return <em>{placeholder}</em>;
        const selectedOption = options.find(
          (opt) =>
            getOptionValue(opt) === selected
        );
        return selectedOption ? renderOption(selectedOption) : <em>{placeholder}</em>;
      }}
    >
      <ListSubheader
        sx={{ pointerEvents: 'auto' }}
        onClick={(e) => e.stopPropagation()}
      >
        <TextField
          fullWidth
          variant="standard"
          placeholder="Buscar..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          inputRef={searchInputRef}
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
          autoFocus
        />
      </ListSubheader>

      {filteredOptions.length > 0 ? (
        filteredOptions.map((option, index) => (
          <MenuItem
            key={getOptionValue(option) || index}
            value={getOptionValue(option)}
          >
            {renderOption(option)}
          </MenuItem>
        ))
      ) : (
        <MenuItem disabled>No hay resultados</MenuItem>
      )}
    </Select>
  );
};

SearchableSelect.propTypes = {
  options: propTypes.array.isRequired,
  value: propTypes.string.isRequired,
  onChange: propTypes.func.isRequired,
  disabled: propTypes.bool,
  renderOption: propTypes.func.isRequired,
  placeholder: propTypes.string
};

export default SearchableSelect;